module.exports = __webpack_public_path__ + "img/ok2.aa500105.svg";